import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60, // 1 minute
      gcTime: 1000 * 60 * 5, // 5 minutes (formerly cacheTime)
      retry: 1,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
    },
    mutations: {
      retry: 0,
    },
  },
});

// Query keys factory for consistent key management
export const queryKeys = {
  // Quotes
  quotes: {
    all: ['quotes'] as const,
    detail: (symbol: string) => ['quotes', symbol] as const,
    history: (symbol: string, params?: Record<string, string>) =>
      ['quotes', symbol, 'history', params] as const,
    realtime: (symbol: string) => ['quotes', symbol, 'realtime'] as const,
    search: (query: string) => ['quotes', 'search', query] as const,
    market: () => ['quotes', 'market'] as const,
  },

  // Analysis
  analysis: {
    all: ['analysis'] as const,
    indicators: (symbol: string, indicators?: string[]) =>
      ['analysis', symbol, 'indicators', indicators] as const,
    trend: (symbol: string) => ['analysis', symbol, 'trend'] as const,
    patterns: (symbol: string) => ['analysis', symbol, 'patterns'] as const,
    supportResistance: (symbol: string) => ['analysis', symbol, 'sr'] as const,
  },

  // Prediction
  prediction: {
    all: ['prediction'] as const,
    detail: (symbol: string, params?: Record<string, unknown>) =>
      ['prediction', symbol, params] as const,
    history: (symbol: string) => ['prediction', symbol, 'history'] as const,
    performance: (symbol: string) => ['prediction', symbol, 'performance'] as const,
  },

  // Backtest
  backtest: {
    all: ['backtest'] as const,
    detail: (id: string) => ['backtest', id] as const,
    history: () => ['backtest', 'history'] as const,
    strategies: () => ['backtest', 'strategies'] as const,
  },

  // Alerts
  alerts: {
    all: ['alerts'] as const,
    history: () => ['alerts', 'history'] as const,
  },

  // User
  user: {
    current: () => ['user', 'me'] as const,
    watchlist: () => ['user', 'watchlist'] as const,
  },

  // Data Center
  dataCenter: {
    coverage: (symbol: string) => ['data-center', 'coverage', symbol] as const,
    snapshot: (symbol: string, dims?: string[]) =>
      ['data-center', 'snapshot', symbol, dims] as const,
  },
};
